module.exports = __webpack_public_path__ + "img/headCover.268c10b5.png";